import { CircuitoResoData } from "./CircuitoResoData";
import React, { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setCircuitoReso } from "../../../context/Actions/turnos/estudioTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import HeaderModal from "../headerModal/headerModal";
import "./Circuito.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";
import { wsGetDatosBioseguridad } from "_+_Portal/context/Actions/paciente/paciente";

const CircuitoReso = ({
  titulo,
  dissmiss,
  danger,
  texto,
  completarFormulario,
}) => {
  const {
    estudioTurnosDispatch,
    estudioTurnosState,
    selectDropDownState,
    pacienteDispatch,
  } = useContext(PortalContext);
  // Toaster Global
  const { authState, toasterDispatch } = useContext(GlobalContext);
  const [circuitoFiltrado, setCircuitoFiltrado] = useState(CircuitoResoData);

  useEffect(() => {
    wsGetDatosBioseguridad(
      selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
        ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
        : "",
      (isCorrect, data) => {
        if (isCorrect && data !== "" && data !== null) {
          const actualizado = CircuitoResoData.map((item) => {
            switch (item.name) {
              case "renal":
                return {
                  ...item,
                  valor: data.flgInsuficienciaRenal === 1 ? true : false,
                };
              case "labFuncionRenal":
                return {
                  ...item,
                  valor: data.flgLabFuncionRenal === 1 ? true : false,
                };
              case "marcaPasos":
                return {
                  ...item,
                  valor: data.flgMarcapasos === 1 ? true : false,
                };
              case "implantesMetalicos":
                return {
                  ...item,
                  valor: data.flgImplanteMetalico === 1 ? true : false,
                };

              case "datosMarcaPasos":
                return {
                  ...item,
                  marca: data.marcaMarcapasos || "",
                  modelo: data.modeloMarcapasos || "",
                  fecha:
                    data.fechaMarcapasos &&
                    data.fechaMarcapasos !== "0001-01-01T00:00:00"
                      ? data.fechaMarcapasos.substring(0, 10) // recorta YYYY-MM-DD
                      : "",
                  visible: data.flgMarcapasos === 1, // mostrar si tenía marcapasos
                };

              case "datosImplantes":
                return {
                  ...item,
                  material: data.materialImpMet || "",
                  ubicacion: data.ubicacionImpMet || "",
                  fecha:
                    data.fechaImpMet &&
                    data.fechaImpMet !== "0001-01-01T00:00:00"
                      ? data.fechaImpMet.substring(0, 10)
                      : "",
                  visible: data.flgImplanteMetalico === 1,
                };

              case "peso":
                return { ...item, valor: data.peso };

              default:
                return item; // los que no mapeás se devuelven igual
            }
          });

          setCircuitoFiltrado(actualizado);
        } else {
          if (data.status !== 404) {
            showToaster(
              {
                texto: "Error al obtener datos de bioseguridad del paciente",
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
          }
        }
      }
    )(pacienteDispatch);
  }, []);

  useEffect(() => {
    console.log(circuitoFiltrado);
  }, [circuitoFiltrado]);

  useEffect(() => {
    // Si es femenino agrego las preguntas sobre embarazo
    if (authState?.auth?.data?.paciente?.sexo === "F") {
      let newObj = [
        {
          pregunta: `¿Usted está embarazada o tiene la sospecha de estarlo?`,
          name: "embarazo",
          valor: null,
          visible: true,
          input: false,
          subitem: false,
          key: 9,
        },
        {
          pregunta: `¿Usted está amamantando?`,
          name: "amamantando",
          valor: null,
          visible: true,
          input: false,
          subitem: false,
          key: 10,
        },
      ];
      setCircuitoFiltrado([...circuitoFiltrado, ...newObj]);
    }
  }, []);

  const onChangeRadio = (e) => {
    const { name, value } = e.target;
    const checked = value === "true";

    let x = { ...estudioTurnosState.estudioTurnos.circuitoReso };
    if (name === "marcaPasos" && checked === false) {
      x = {
        ...x,
        modeloMarcapasos: "",
        marcaMarcapasos: "",
        fechaMarcapasos: "",
      };
    } else if (name === "modeloMarcapasos" && checked === false) {
      x = {
        ...x,
        materialImpMet: "",
        ubicacionImpMet: "",
        fechaImpMet: "",
      };
    }
    let arrX = [...circuitoFiltrado];

    // Reglas de dependencias
    const rules = {
      contraste: {
        true: {
          updateState: { contraste: true },
          updateArr: [{ name: "renal", visible: true }],
        },
        false: {
          updateState: { contraste: false, renal: false },
          updateArr: [{ name: "renal", visible: false, valor: null }],
        },
      },
      renal: {
        true: {
          updateState: { renal: true },
          updateArr: [{ name: "labFuncionRenal", visible: true }],
        },
        false: {
          updateState: { renal: false, labFuncionRenal: false },
          updateArr: [{ name: "labFuncionRenal", visible: false, valor: null }],
        },
      },
      marcaPasos: {
        true: {
          updateState: { marcaPasos: true },
          updateArr: [{ name: "datosMarcaPasos", visible: true }],
        },
        false: {
          updateState: { marcaPasos: false, datosMarcaPasos: false },
          updateArr: [
            { name: "datosMarcaPasos", visible: false, valor: "" },
            { name: "marcaMarcapasos", visible: false, valor: null },
            { name: "modeloMarcapasos", visible: false, valor: null },
            { name: "fechaMarcapasos", visible: false, valor: null },
          ],
        },
      },
      implantesMetalicos: {
        true: {
          updateState: { implantesMetalicos: true },
          updateArr: [{ name: "datosImplantes", visible: true }],
        },
        false: {
          updateState: { implantesMetalicos: false, datosImplantes: false },
          updateArr: [
            { name: "datosImplantes", visible: false, valor: "" },
            { name: "materialImpMet", visible: false, valor: null },
            { name: "ubicacionImpMet", visible: false, valor: null },
            { name: "fechaImpMet", visible: false, valor: null },
          ],
        },
      },
    };

    // Aplicar la regla si existe
    if (rules[name]) {
      const rule = rules[name][value];
      if (rule.updateState) {
        x = { ...x, ...rule.updateState };
      }
      if (rule.updateArr) {
        arrX = arrX.map((item) => {
          const found = rule.updateArr.find((r) => r.name === item.name);
          return found ? { ...item, ...found } : item;
        });
      }
    } else {
      // Caso genérico (no tiene reglas)
      x = { ...x, [name]: checked };
    }

    // Siempre actualizamos el valor del item actual
    arrX = arrX.map((item) =>
      item.name === name ? { ...item, valor: checked } : item
    );
    setCircuitoReso(x)(estudioTurnosDispatch);
    setCircuitoFiltrado(arrX);
  };

  const onChangeInput = (e) => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoReso);
    const { name, value } = e.target;
    setCircuitoFiltrado((prev) =>
      prev.map((item) =>
        item.name === name ? { ...item, valor: value } : item
      )
    );
    setCircuitoReso({
      ...x,
      [name]: value,
    })(estudioTurnosDispatch);
  };

  const onChangeMultiInput = (e, name) => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoReso);
    const { value } = e.target;
    setCircuitoFiltrado((prev) =>
      prev.map((item) =>
        item.name === name ? { ...item, valor: value } : item
      )
    );
    setCircuitoReso({
      ...x,
      [name]: value,
    })(estudioTurnosDispatch);
  };

  const onClickVolverCirc = () => {
    setCircuitoFiltrado(CircuitoResoData);
    dissmiss();
  };

  const onClickBusqCirc = () => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoReso);
    let arrX = circuitoFiltrado;
    arrX = arrX.filter((item) => (item.visible === true ? item : ""));
    arrX = arrX.filter((item) => item.valor === null);
    if (arrX.length > 0) {
      showToaster(
        {
          texto: "Complete las preguntas!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      setCircuitoFiltrado(CircuitoResoData);
      // completarFormulario("RESO", x)
      setCircuitoReso({
        ...x,
        flgForm: true,
      })(estudioTurnosDispatch);
    }
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />
      <div className="ptur-circuito-bodyModal">
        <div className="ptur-circuito-tituloDesc">
          <p className="rb18l titulo-circuito">{texto}</p>
        </div>
        <div className="ptur-circuito-box">
          {circuitoFiltrado.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {item.visible && (
                  <div className="ptur-circuito-boxPreguntas">
                    <div className="ptur-circuito-preguntaDesc">
                      <span className={item.subitem ? "rb14l" : "rb14b"}>
                        {item.pregunta}
                      </span>
                    </div>
                    {item.input ? (
                      <div className="ptur-circuito-input">
                        <input
                          type="number"
                          name={item.name}
                          onChange={(e) => onChangeInput(e)}
                          value={item.valor}
                          className={"ptur-input-peso inputNonScroll"}
                        />
                        <p>kg</p>
                      </div>
                    ) : item.multiInput ? (
                      <div className="ptur-circuito-input-desc">
                        <div className="ptur-desc-item">
                          <p className="ptur-input-txt rb14l">
                            {item.name === "datosMarcaPasos"
                              ? "Marca"
                              : "Material"}
                          </p>
                          <input
                            type="text"
                            name={item.name}
                            onChange={(e) =>
                              onChangeMultiInput(
                                e,
                                item.name === "datosMarcaPasos"
                                  ? "marcaMarcapasos"
                                  : "materialImpMet"
                              )
                            }
                            value={
                              item.name === "datosMarcaPasos"
                                ? item.marca
                                : item.material
                            }
                            className={"ptur-input-descripcion"}
                          />
                        </div>
                        <div className="ptur-desc-item">
                          <p className="ptur-input-txt rb14l">
                            {item.name === "datosMarcaPasos"
                              ? "Modelo"
                              : "Ubicación"}
                          </p>
                          <input
                            type="text"
                            name={item.name}
                            onChange={(e) =>
                              onChangeMultiInput(
                                e,
                                item.name === "datosMarcaPasos"
                                  ? "modeloMarcapasos"
                                  : "ubicacionImpMet"
                              )
                            }
                            value={
                              item.name === "datosMarcaPasos"
                                ? item.modelo
                                : item.ubicacion
                            }
                            className={"ptur-input-descripcion"}
                          />
                        </div>
                        <div className="ptur-desc-item">
                          <p className="ptur-input-txt rb14l">
                            Fecha colocación
                          </p>
                          <input
                            type="date"
                            name={item.name}
                            onChange={(e) =>
                              onChangeMultiInput(
                                e,
                                item.name === "datosMarcaPasos"
                                  ? "fechaMarcapasos"
                                  : "fechaImpMet"
                              )
                            }
                            value={item.fecha}
                            className={"ptur-input-descripcion"}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="ptur-circuito-radios">
                        <span>
                          <InputV1
                            nombreRadio={item.name}
                            onChange={onChangeRadio}
                            value={true}
                            inputType="radio"
                            labelStr={"Sí"}
                            radioClass="ptur-circuito-radio"
                            noHeight={true}
                            checked={item.valor === true}
                          />
                        </span>
                        <span>
                          <InputV1
                            nombreRadio={item.name}
                            onChange={onChangeRadio}
                            value={false}
                            inputType="radio"
                            labelStr={"No"}
                            radioClass="ptur-circuito-radio"
                            noHeight={true}
                            checked={item.valor === false}
                          />
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className="ptur-circuito-boxBtn">
          <button
            className="ptur-circuito-btnVolver c-latex30 rb16m"
            onClick={onClickVolverCirc}
          >
            Volver
          </button>
          <button
            className="ptur-circuito-btnBusq c-white rb16m"
            onClick={onClickBusqCirc}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </>
  );
};

export default CircuitoReso;
